(function () {
  function portalCollectionSearch() {
    var slot = document.getElementById('CollectionSearchSlot');
    if (!slot) return;
    if (slot.getAttribute('data-portal-to-hero') !== 'true') return;

    var target = document.getElementById('CollectionSearchTarget');
    if (!target) return;
    if (slot.parentElement === target) return;

    target.appendChild(slot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', portalCollectionSearch);
  } else {
    portalCollectionSearch();
  }

  document.addEventListener('shopify:section:load', portalCollectionSearch);
  document.addEventListener('shopify:section:reorder', portalCollectionSearch);
})();
